import {Component} from '@angular/core';

@Component({
    selector: 'app-neo',
    templateUrl: './neo.component.html',
    styleUrls: ['./neo.component.scss'],
    standalone: false
})
export class NeoComponent {
}
